import { useMutation } from "@apollo/client";
import { XIcon } from "@heroicons/react/outline";
import {
  GoalCompetencyFragmentFragment,
  GoalRoleFragmentFragment,
  UpdateGoalGrowthConnectionsMutationMutation,
  UpdateGoalGrowthConnectionsMutationMutationVariables,
} from "types/graphql-schema";

import getCareerRoleRelatedDataQuery from "@apps/profile/career-tab/graphql/get-career-role-related-data-query";
import useLabel from "@apps/use-label/use-label";
import Loading from "@components/loading/loading";
import { Tooltip } from "@components/tooltip/tooltip";

import updateGoalGrowthConnectionsMutation from "../graphql/update-goal-growth-connections-mutation";

const GoalOwnerRoleCompetency = ({
  role,
  goalId,
  competency,
  goalCompetencyRoleItemIds,
}: {
  role: GoalRoleFragmentFragment;
  goalId: number;
  competency: GoalCompetencyFragmentFragment;
  goalCompetencyRoleItemIds: { competencyId: number; roleId: number }[];
}) => {
  const label = useLabel();
  const [updateGoalGrowthConnections, { loading: loadingMutation }] =
    useMutation<
      UpdateGoalGrowthConnectionsMutationMutation,
      UpdateGoalGrowthConnectionsMutationMutationVariables
    >(updateGoalGrowthConnectionsMutation);

  const handleRemoveCompetency = () => {
    const newCompetencyIds = goalCompetencyRoleItemIds.filter(
      (item) => item.competencyId !== competency.id || item.roleId !== role.id,
    );
    updateGoalGrowthConnections({
      variables: {
        artifactId: goalId,
        additionalFields: { competencyIds: newCompetencyIds },
      },

      refetchQueries: [getCareerRoleRelatedDataQuery],
    });
  };
  return (
    <div
      className="flex items-center gap-2 py-0.5 px-2 rounded bg-gray-100"
      key={competency.id}
    >
      {competency.title}
      {loadingMutation ? (
        <Loading mini size={3} />
      ) : (
        <Tooltip text={`Remove ${label("competency")}`}>
          <button
            className="text-gray-400 hover:text-gray-600"
            onClick={handleRemoveCompetency}
            disabled={loadingMutation}
          >
            <XIcon className="w-3 h-3" />
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default GoalOwnerRoleCompetency;
